import React from 'react';
import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import { ModuleBase, TrackEventKey } from '@/components';
import ReportModulHeader from '@/components/report/ReportModulHeader';
import { useTranslations } from 'next-intl';
import AtAGlance, { AtAGlanceModel } from '@/components/report/ataglance/AtAGlance';

export type AtAGlanceModuleModel = ModuleBaseModel<
  { collapseAtaGlance?: boolean } & AtAGlanceModel & ModuleBasePropsModel
>;

const AtAGlanceModule = (data: AtAGlanceModuleModel) => {
  const {
    props: { collapseAtaGlance },
  } = data;
  const t = useTranslations();
  return (
    <ModuleBase
      data={{
        ...data,
        props: {
          ...data.props,
          backgroundColour: '#f2f2f2',
          anchor: 'report-at-a-glance',
        },
      }}
      noPadding
      style={{ pageBreakBefore: 'always' }}
    >
      <div className="container pt-0 sm:py-11">
        <ReportModulHeader
          title={t('report.$atAGlance')}
          expanded={!collapseAtaGlance}
          eventKey={TrackEventKey.AT_A_GLANCE}
          saveOpenStateKey="atAGlanceModule"
        >
          <AtAGlance {...data.props} backgroundColour="#f2f2f2" />
        </ReportModulHeader>
      </div>
    </ModuleBase>
  );
};

export default AtAGlanceModule;
